import * as Sentry from '@sentry/react'
// Circular with set-crisp-session-info (it imports yieldToCrisp); safe because
// both modules only call each other's functions at runtime, never during init.
import { showChat } from './set-crisp-session-info'

let yieldHandler: (() => void) | null = null
let attachedCrisp: unknown = null

export const registerCrispYieldHandler = (handler: () => void): (() => void) => {
  yieldHandler = handler
  return () => {
    if (yieldHandler === handler) {
      yieldHandler = null
    }
  }
}

export const yieldToCrisp = (): void => {
  try {
    yieldHandler?.()
  } catch (err) {
    Sentry.captureException(err)
  }
}

// Crisp triggers whose only action is "show chatbox" (no message) emit neither
// message:received nor chat:opened, so they won't make the panel yield. Any
// subsequent message re-surfaces Crisp, so it is never permanently suppressed.
// Guard by $crisp identity, not a boolean: the App effect replaces window.$crisp
// with a fresh array on re-mount, and listeners must land on the array Crisp consumes.
export const attachCrispPriorityListeners = (): void => {
  if (!window.$crisp || attachedCrisp === window.$crisp) {
    return
  }
  attachedCrisp = window.$crisp
  const surfaceCrisp = () => {
    yieldToCrisp()
    // showChat (not a raw push) so the chatHidden flag tracks the real widget state.
    showChat()
  }
  window.$crisp.push(['on', 'message:received', surfaceCrisp])
  window.$crisp.push(['on', 'chat:opened', surfaceCrisp])
}
